import { reduxKey } from './constants';
import { getDeviationById } from '../../redux/deviations/selectors';
export var getWriterDeviation = function (state) {
    return getDeviationById(state, state[reduxKey] && state[reduxKey].deviationId);
};
export var getWriterError = function (state) { return state[reduxKey] && state[reduxKey].error; };
export var getIsWriterSubmitting = function (state) {
    return state[reduxKey] && state[reduxKey].isSubmitting;
};
export var getIsWriterDeviationFeatured = function (state) {
    return (state[reduxKey] && state[reduxKey].isFeatured) || false;
};
export var getIsWriterDeviationMature = function (state) {
    return (state[reduxKey] && state[reduxKey].isMature) || false;
};
export var getIsRedirecting = function (state) {
    return (state[reduxKey] && state[reduxKey].isRedirecting) || false;
};
//# sourceMappingURL=selectors.js.map